/**
 * Salt Room Carousel - Fixed Version
 * Added error handling and browser compatibility
 */
(function() {
    'use strict';
    
    try {
        // Prevent multiple initializations
        if (window.SaltRoomCarousel) return;
        window.SaltRoomCarousel = true;
        
        var currentSlide = 0;
        var totalSlides = 11;
        
        function showSlide(n) {
            try {
                var slides = document.querySelectorAll('.carousel-slide');
                var dots = document.querySelectorAll('.dot');
                
                if (!slides || slides.length === 0) return;
                
                currentSlide = n;
                if (currentSlide >= totalSlides) currentSlide = 0;
                if (currentSlide < 0) currentSlide = totalSlides - 1;
                
                for (var i = 0; i < slides.length; i++) {
                    slides[i].style.display = 'none';
                    slides[i].classList.remove('active');
                }
                for (var j = 0; j < dots.length; j++) {
                    dots[j].classList.remove('active');
                }
                
                if (slides[currentSlide]) {
                    slides[currentSlide].style.display = 'block';
                    slides[currentSlide].classList.add('active');
                }
                if (dots[currentSlide]) {
                    dots[currentSlide].classList.add('active');
                }
                
                updateMenuItems();
            } catch (e) {
                console.warn('Carousel showSlide error:', e);
            }
        }
        
        function updateMenuItems() {
            try {
                var items = document.querySelectorAll('.video-menu-item');
                for (var i = 0; i < items.length; i++) {
                    var slideIndex = parseInt(items[i].getAttribute('data-slide'));
                    if (slideIndex === currentSlide) {
                        items[i].classList.add('active');
                    } else {
                        items[i].classList.remove('active');
                    }
                }
            } catch (e) {
                console.warn('Carousel updateMenuItems error:', e);
            }
        }
        
        function nextSlide() {
            showSlide(currentSlide + 1);
        }
        
        function prevSlide() {
            showSlide(currentSlide - 1);
        }
        
        function goToSlide(n) {
            showSlide(n);
        }
        
        // Safe matches check with fallback
        function elementMatches(element, selector) {
            if (!element) return false;
            try {
                var matches = element.matches || element.webkitMatchesSelector || element.msMatchesSelector;
                if (matches) {
                    return matches.call(element, selector);
                }
            } catch (e) {}
            return false;
        }
        
        // Safe closest with fallback
        function findClosest(element, selector) {
            if (!element) return null;
            try {
                if (element.closest) {
                    return element.closest(selector);
                }
                // Fallback for older browsers
                var el = element;
                while (el) {
                    if (elementMatches(el, selector)) return el;
                    el = el.parentElement;
                }
            } catch (e) {}
            return null;
        }
        
        // Single global click handler with error handling
        document.addEventListener('click', function(e) {
            try {
                var target = e.target;
                if (!target) return;
                
                // Previous button
                if (elementMatches(target, '.carousel-prev') || findClosest(target, '.carousel-prev')) {
                    e.preventDefault();
                    e.stopPropagation();
                    prevSlide();
                    return false;
                }
                
                // Next button
                if (elementMatches(target, '.carousel-next') || findClosest(target, '.carousel-next')) {
                    e.preventDefault();
                    e.stopPropagation();
                    nextSlide();
                    return false;
                }
                
                // Dots
                if (elementMatches(target, '.dot')) {
                    e.preventDefault();
                    var slideNum = parseInt(target.getAttribute('data-slide'));
                    if (!isNaN(slideNum)) goToSlide(slideNum);
                    return false;
                }
                
                // Video menu items
                var menuItem = findClosest(target, '.video-menu-item');
                if (menuItem) {
                    e.preventDefault();
                    var slideNum = parseInt(menuItem.getAttribute('data-slide'));
                    if (!isNaN(slideNum)) goToSlide(slideNum);
                    return false;
                }
            } catch (e) {
                console.warn('Carousel click handler error:', e);
            }
        }, true);
        
        // Initialize
        function init() {
            try {
                var slides = document.querySelectorAll('.carousel-slide');
                if (slides.length > 0) {
                    showSlide(0);
                }
            } catch (e) {
                console.warn('Carousel init error:', e);
            }
        }
        
        // Run on ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        } else {
            init();
        }
        
    } catch (e) {
        console.warn('Carousel initialization failed:', e);
    }
})();
